import React from 'react';
import styles from './UIGameBottomLandscape.module.scss';
import { UIGameTradeCreator } from '../UIGameTradeCreator/UIGameTradeCreator.tsx';
import { UIGameActionButtonContainer } from '../UIGameActionButtonsContainer/index.ts';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGameActionBoxContainer } from '../UIGameActionBox/UIGameActionBoxContainer.tsx';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
import clsx from 'clsx';
import { UIGameDiceGroupContainer } from '../../common/UIGameDiceGroup/UIGameDiceGroupContainer.tsx';
export const UIGameBottomLandscape = ()=>{
    const isReplay = useIsReplay();
    const myColor = useGameStore((state)=>state.myColor);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.bottomContainerLandscape, {
            [styles.replay]: isReplay || isMyColorSpectator
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.actionBoxContainer
    }, /*#__PURE__*/ React.createElement(UIGameActionBoxContainer, null)), isMyColorSpectator ? /*#__PURE__*/ React.createElement("div", {
        className: styles.gameInventorySpectatorContainer
    }) : /*#__PURE__*/ React.createElement(UIGameTradeCreator, {
        className: styles.gameInventoryContainer
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.rightContainer
    }, /*#__PURE__*/ React.createElement(UIGameDiceGroupContainer, {
        playerColor: myColor,
        size: "large",
        className: styles.diceGroup
    }), /*#__PURE__*/ React.createElement(UIGameActionButtonContainer, {
        className: styles.actionButtonContainer
    })));
};
